import AsyncStorage from '@react-native-async-storage/async-storage';
import { notificationService } from '../../services/notification-service';
import type { UserSessionAttributes } from '../../models/user-session-model';

/**
 * Stores the user session object in AsyncStorage
 * @param userSession - Object containing user session data based on UserSessionAttributes
 */
export const storeUserSession = async (
  userSession: UserSessionAttributes
): Promise<void> => {
  try {
    await AsyncStorage.setItem('userSession', JSON.stringify(userSession));
  } catch (error) {
    console.error('Error storing user session: ', error);
    notificationService.sendNotification(
      'error',
      `Unable to store user session! ${String(error)}`
    );
  }
};


